import { GlobalEvents } from 'client/Other/GlobalEvents'
import * as React from 'react'
import { ResizeObserver } from 'resize-observer'

import Button, { ButtonType } from '../Button/Button'
import { InputInterface } from '../Input/InputInterface'
import { Modal } from '../Modal/Modal'
import './FreeTextInput.scss'

export interface FreeTextInputSelectionInterface {
  id: number
  text: string
}

export interface FreeTextInputPropsInterface extends InputInterface<string> {
  rows?: number
  values?: FreeTextInputSelectionInterface[]
  selectButtonLabel: string
  selectHeader: string
  saveButtonLabel: string
  closeButtonLabel: string
  resizable?: boolean
  onSave: (value: string) => void
  onDelete: (id: number) => void
}

export interface FreeTextInputStateInterface {
  value: string
  selectOpen: boolean
  selected?: number
  focused: boolean
  menuOpen: boolean
  height?: number
}

export class FreeTextInput extends React.Component<FreeTextInputPropsInterface, FreeTextInputStateInterface> {
  constructor(props: FreeTextInputPropsInterface) {
    super()

    this.state = {
      value: props.value,
      selectOpen: false,
      focused: false,
      menuOpen: false,
      height: 32,
    }
  }

  private input: HTMLTextAreaElement

  public static defaultProps: FreeTextInputPropsInterface = {
    value: '',
    className: ['FreeTextInput'],
    automation: '',
    borderless: false,
    values: [],
    selectHeader: 'Select value',
    selectButtonLabel: 'Select',
    saveButtonLabel: 'Save',
    closeButtonLabel: 'Close',
    onChange: () => {},
    onSave: () => {},
    onDelete: () => {},
    editable: true,
  }

  private handleOnBlur(e: Event) {
    const value: string = (e.target as HTMLInputElement).value
    if (this.props.onBlur) {
      this.props.onBlur(value)
    }
    this.setState({ focused: false })
  }

  private handleOnChange(e: Event) {
    const value: string = (e.target as HTMLInputElement).value
    this.setState({ value })
    // this.props.onChange(value);
  }

  public UNSAFE_componentWillReceiveProps(props: FreeTextInputPropsInterface) {
    if ((!props.values || props.values.length === 0) && this.state.selectOpen !== false) {
      this.setState({ selectOpen: false })
    }
    if (props.value !== this.state.value) {
      this.setState({ value: props.value })
    }
  }

  private e
  public componentDidMount() {
    const ro = new ResizeObserver(() => {
      this.setState({ height: this.input?.clientHeight })
    })
    if (this.input) {
      ro.observe(this.input)
    }
    this.e = GlobalEvents.Click((e) => {
      this.setState({ menuOpen: false })
    })
  }

  public componentWillUnmount() {
    GlobalEvents.unBind(this.e)
  }

  public render(): JSX.Element {
    const classes = ['Controlled', 'Input']
    if (this.props.borderless) {
      classes.push('Borderless')
    }

    let label = null
    if (this.props.label) {
      label = (
        <span
          className="Label"
          data-automation={this.props.automation + '-label'}
          onClick={() => {
            this.input.focus()
          }}
        >
          {this.props.label}
        </span>
      )
      classes.push('hasLabel')
    }

    const baseClasses = ['Controlled', 'Input', 'FreeTextInput']
    const textAreaClasses = ['Controlled Borderless']

    if (this.props.labelPosition && this.props.labelPosition == 'top') {
      baseClasses.push('LabelOnTop')
    }
    if (this.props.invalid) {
      baseClasses.push('invalid')
    }

    if (this.state.selectOpen) {
      baseClasses.push('selectOpen')
    }

    if (this.props?.resizable) {
      textAreaClasses.push('resizable')
    }

    const modalValues = []
    let selectButton
    let menu = null
    let dropdown = null
    let focus = ''
    let menuClass = ''
    const resizableHeight = this.props.resizable ? { height: String(this.state?.height) + 'px', margin: '0px' } : {}
    if (this.props.values && this.props.values.length > 0 && this.props.editable) {
      this.props.values.forEach((sel) => {
        modalValues.push(
          <div className="selectionRow" data-automation={this.props.automation + '-selectionrow'} key={sel.id}>
            <div
              className="selection"
              data-automation={this.props.automation + '-select-value'}
              onClick={() => {
                this.setState({ selected: sel.id, value: sel.text, selectOpen: false })
                this.input.focus()
              }}
            >
              {sel.text}
            </div>
            <span
              className="delete"
              data-automation={this.props.automation + '-select-delete'}
              onClick={() => {
                this.props.onDelete(sel.id)
              }}
            ></span>
          </div>,
        )
      })
      selectButton = (
        <div
          className="selectButton btn"
          data-automation={this.props.automation + '-selectbtn'}
          onClick={() => {
            this.setState({ selectOpen: true })
          }}
        >
          {this.props.selectButtonLabel}
        </div>
      )
    }
    if (this.state.menuOpen) {
      menuClass = ' menuopen'
    }
    if (this.props.editable) {
      dropdown = (
        <div
          data-automation={this.props.automation + '-dropdown'}
          className={'dropdown' + menuClass}
          onClick={(e) => {
            this.setState({ menuOpen: !this.state.menuOpen })
            GlobalEvents.stop(e)
            return false
          }}
        ></div>
      )
    }
    if (this.state.menuOpen) {
      menu = (
        <div
          className="freetext-menu "
          onClick={() => {
            this.setState({ menuOpen: false })
          }}
        >
          {this.props.editable && (
            <div
              className="saveButton btn"
              data-automation={this.props.automation + '-savebtn'}
              onClick={() => {
                this.props.onSave(this.state.value)
              }}
            >
              {this.props.saveButtonLabel}
            </div>
          )}
          {selectButton}
        </div>
      )
    }
    if (this.state.focused) {
      focus = ' focus'
    }

    return (
      <div style={resizableHeight} className={baseClasses.join(' ')}>
        {label}
        <div style={resizableHeight} className={'Controlled freeTextControl' + focus}>
          <div style={resizableHeight} className={classes.join(' ') + ' ' + this.props.className.join(' ')}>
            <textarea
              className={textAreaClasses.join(' ')}
              ref={(area) => {
                this.input = area
              }}
              data-automation={this.props.automation + '-textarea'}
              type="text"
              value={this.state.value}
              onChange={this.handleOnChange.bind(this)}
              onBlur={this.handleOnBlur.bind(this)}
              size={this.props.size}
              maxLength={this.props.maxLength}
              rows={this.props.rows}
              placeholder={this.props.placeHolder}
              onFocus={() => {
                this.setState({ focused: true })
              }}
              readOnly={!this.props.editable}
            />
            {dropdown}
            {menu}
          </div>
        </div>
        {this.state.selectOpen && (
          <Modal
            isOpen={this.state.selectOpen}
            size="medium"
            automation={this.props.automation + '-modal'}
            header={this.props.selectHeader}
            onClose={() => {
              this.setState({ selectOpen: false })
            }}
          >
            <div className="selections">{modalValues}</div>
            <footer>
              <Button
                label={this.props.closeButtonLabel}
                action={() => {
                  this.setState({ selectOpen: false })
                }}
                type={ButtonType.cancel}
                automation={this.props.automation + '-closebtn'}
              />
            </footer>
          </Modal>
        )}
      </div>
    )
  }
}
